<template>
  <div class="share-flow-modal">
    <CustomModal @onClose="close">
      <div class="share-flow-modal-content-wrapper" ref="shareModal">
        <div class="content">
          <div>
            <h3 class="content-title">Flow Teilen</h3>
            <p class="content-paragraph">
              Teilen Sie Ihren Flow mit anderen Personen.
            </p>
          </div>

          <form @submit.prevent="save()">
            <div class="input-field">
              <input
                class="email-input"
                placeholder="E-Mail-Adresse"
                v-model="shareParams.email"
                type="email"
                required
              />
              <CustomDropdown className="permission-selector form-input">
                <template v-slot:selected-option>
                  <span class="line-clamp"
                    >{{
                      getShareParamsAccessLevelName(shareParams.accessLevel)
                    }}
                  </span>
                </template>
                <template v-slot:option-data>
                  <b-dropdown-item
                    v-for="(level, index) in getDropDownAccessLevels"
                    :key="level.name"
                    @click="setShareParamsAccessLevel(level.name)"
                    :active="shareParams.accessLevel === level.name"
                  >
                    <template v-if="index !== 0">
                      {{ level.caption }}
                    </template>
                    <template v-if="index === 0">
                      <div class="d-flex justify-content-between w-100">
                        <span>{{ level.caption }}</span>

                        <span>
                          <img
                            class="button-icon"
                            :src="require('../../assets/img/chevron-down.svg')"
                        /></span>
                      </div>
                    </template>
                  </b-dropdown-item>
                </template>
              </CustomDropdown>
            </div>
            <div class="form-element-wrapper">
              <CommonButton
                class="common-button-component"
                :isLoading="isLoadingShareFlowButton"
                :isDisabled="isLoadingShareFlowButton"
              >
                Teilen
              </CommonButton>
            </div>
          </form>
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import { workFlowAccessLevels } from '../../enum/auth.enum';
import { shareWorkFlow } from '../../services/workflow.service';
import CustomDropdown from '../widgets/CustomDropdown.vue';
import CustomModal from './CustomModal.vue';
import CommonButton from '../widgets/CommonButton.vue';
export default {
  name: 'ShareMultipleFlowsModal',
  data() {
    return {
      shareParams: {
        email: null,
        accessLevel: 'execute',
      },
      isLoadingShareFlowButton: false,
    };
  },
  props: {
    flows: Array,
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    save: async function () {
      try {
        this.isLoadingShareFlowButton = true;
        await this.shareFlow({
          recipient: this.shareParams.email,
          access_level: this.shareParams.accessLevel,
        });
        this.shareParams.email = null;
        this.showToaster(
          'Workflow wurde erfolgreich geteilt',
          'Erfolg',
          'success'
        );
      } catch (error) {
        this.showToaster(error.message, 'Fehlerhaft !', 'danger');
      } finally {
        this.isLoadingShareFlowButton = false;
      }
    },
    async shareFlow({ recipient, access_level }) {
      try {
        await Promise.allSettled(
          this.flows.map(async (flow) => {
            let payload = {
              recipient,
              flow_id: flow.id,
              access_level,
            };
            return await shareWorkFlow(payload, true);
          })
        );
      } catch (error) {
        if (error && error.status === 400 && error.data && error.data.message) {
          let message = error.data.message;
          if (message.includes('The Access of the owner cannot be changed')) {
            this.showToaster(
              'Dieser User hat den Flow erstellt, du kannst ihn nicht einladen',
              'Fehlerhaft !',
              'danger'
            );
          } else if (message.includes('E-mail not found')) {
            this.showToaster(
              'Die angegebene Email-Adresse konnte nicht gefunden werden.',
              'Fehlerhaft !',
              'danger'
            );
          }
        } else if (error.status === 404) {
          this.showToaster(
            'Die angegebene Email-Adresse konnte nicht gefunden werden.',
            'Fehlerhaft !',
            'danger'
          );
        }
        throw error;
      }
    },

    setShareParamsAccessLevel(accessName) {
      this.shareParams.accessLevel = accessName;
    },
    getShareParamsAccessLevelName(accessLevel) {
      return workFlowAccessLevels.find((level) => level.name == accessLevel)
        .caption;
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
  },
  computed: {
    getDropDownAccessLevels() {
      return workFlowAccessLevels.filter((el) => el.name !== 'owner');
    },
    user() {
      return this.$store.state.user;
    },
  },
  components: {
    CustomModal,
    CommonButton,
    CustomDropdown,
  },
};
</script>

<style scoped>
.share-flow-modal .share-flow-modal-content-wrapper {
  height: 355px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 98px;
  padding-block: 70px;
}
@media (max-width: 767px) {
  .share-flow-modal .share-flow-modal-content-wrapper {
    padding-inline: 40px;
  }
}
.share-flow-modal .content {
  width: 100%;
  height: fit-content;
}

.share-flow-modal .content-title {
  font-size: 20px;
  color: #333343;
  margin: 0;
  font-weight: 400;
  text-transform: uppercase;
  padding: 0 6px;
}

.share-flow-modal .content-paragraph {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #333343;
  margin: 20px 0;
  padding: 0 6px;
}

.share-flow-modal .email-input {
  outline: none;
  border: 0.5px solid #333343;
  border-radius: 4px;
  width: 330px;
  height: 34px;
  font-size: 16px;
  padding: 4px 16px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(51, 51, 51);
}

@media (max-width: 767px) {
  .share-flow-modal .email-input {
    width: 100%;
    max-width: 100%;
  }
}
.share-flow-modal .email-input::placeholder {
  color: rgba(51, 51, 51, 0.24);
}
.share-flow-modal .form-element-wrapper {
  padding-top: 36px;
  position: relative;
}
.share-flow-modal .custom-dropdown.permission-selector {
  border-radius: 4px;
  font-size: 13px;
  width: 158px;
  display: flex;
  height: 100%;
}
.share-flow-modal
  ::v-deep
  .custom-dropdown.permission-selector.form-input
  .custom-dropdown-toggle {
  height: 34px;
}

::v-deep .dropdown-item.active {
  background: #e5e5e591;
}

.share-flow-modal .loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.share-flow-modal ::v-deep .loading-wrapper .progress-icon-wrapper {
  position: unset;
}

.share-flow-modal
  ::v-deep
  .permission-selector.form-input
  .custom-dropdown-toggle
  img {
  margin-top: 3px;
}

.share-flow-modal ::v-deep .permission-selector.active .button-icon {
  transform: rotate(180deg);
  width: 9px;
}

.share-flow-modal .input-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 767px) {
  .share-flow-modal .input-field {
    flex-direction: column;
    align-items: flex-start;
  }
}
.share-flow-modal form {
  padding: 0 6px;
}
</style>
